module.exports = __webpack_public_path__ + "img/avatar0.3cbc6e65.png";